import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { RootState } from './index'

export interface TruckImageState {
  imageUrl: string | undefined
}

const initialState: TruckImageState = {
  imageUrl: undefined,
}

export const truckImageSlice = createSlice({
  name: 'truckImage',
  initialState,
  reducers: {
    setTruckImageUrl: (state, action: PayloadAction<string | undefined>) => {
      state.imageUrl = action.payload
    },
  },
})

export const { setTruckImageUrl } = truckImageSlice.actions

export const getTruckImageState = (state: RootState) => state.truckImage

export default truckImageSlice.reducer
